/**
 * ETP Social Sharing – copy-link, Web Share API, and responsive More dropdown.
 *
 * Handles:
 *   [data-etp-ss-action="copy"] – copies data-url to clipboard, shows feedback
 *   [data-etp-ss-action="more"] – toggles overflow dropdown
 */

// Breakpoint and hardcoded visibility thresholds.
// Aligned with SCSS bp-s (S/M tier boundary).
const MOBILE_BREAKPOINT = 900;

const MAX_VISIBLE = {
  mobile:  3,  // ≤ 900px
  default: 4,  // > 900px
};

// SVG icon map for dropdown items (mirrors PHP get_icon())
const ICONS = {
  copy_link:   '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></svg>',
  facebook:    '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg>',
  twitter:     '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>',
  linkedin:    '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/><rect x="2" y="9" width="4" height="12"/><circle cx="4" cy="4" r="2"/></svg>',
  bluesky:     '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 600 530" fill="currentColor" aria-hidden="true" focusable="false"><path d="m135.72 44.03c66.496 49.921 138.02 151.14 164.28 205.46 26.262-54.316 97.782-155.54 164.28-205.46 47.98-36.021 125.72-63.892 125.72 24.795 0 17.712-10.155 148.79-16.111 170.07-20.703 73.984-96.144 92.854-163.25 81.433 117.3 19.964 147.14 86.092 82.697 152.22-122.39 125.59-175.91-31.511-189.63-71.766-2.514-7.3797-3.6904-10.832-3.7077-7.8964-0.0174-2.9357-1.1937 0.51669-3.7077 7.8964-13.714 40.255-67.233 197.36-189.63 71.766-64.444-66.128-34.605-132.26 82.697-152.22-67.108 11.421-142.55-7.4491-163.25-81.433-5.9562-21.282-16.111-152.36-16.111-170.07 0-88.687 77.742-60.816 125.72-24.795z"/></svg>',
  reddit:      '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false"><path d="M12 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0zm5.01 4.744c.688 0 1.25.561 1.25 1.249a1.25 1.25 0 0 1-2.498.056l-2.597-.547-.8 3.747c1.824.07 3.48.632 4.674 1.488.308-.309.73-.491 1.207-.491.968 0 1.754.786 1.754 1.754 0 .716-.435 1.333-1.01 1.614a3.111 3.111 0 0 1 .042.52c0 2.694-3.13 4.87-7.004 4.87-3.874 0-7.004-2.176-7.004-4.87 0-.183.015-.366.043-.534A1.748 1.748 0 0 1 4.028 12c0-.968.786-1.754 1.754-1.754.463 0 .898.196 1.207.49 1.207-.883 2.878-1.43 4.744-1.487l.885-4.182a.342.342 0 0 1 .14-.197.35.35 0 0 1 .238-.042l2.906.617a1.214 1.214 0 0 1 1.108-.701zM9.25 12C8.561 12 8 12.562 8 13.25c0 .687.561 1.248 1.25 1.248.687 0 1.248-.561 1.248-1.249 0-.688-.561-1.249-1.249-1.249zm5.5 0c-.687 0-1.248.561-1.248 1.25 0 .687.561 1.248 1.249 1.248.688 0 1.249-.561 1.249-1.249 0-.687-.562-1.249-1.25-1.249zm-5.466 3.99a.327.327 0 0 0-.231.094.33.33 0 0 0 0 .463c.842.842 2.484.913 2.961.913.477 0 2.105-.056 2.961-.913a.361.361 0 0 0 .029-.463.33.33 0 0 0-.464 0c-.547.533-1.684.73-2.512.73-.828 0-1.979-.196-2.512-.73a.326.326 0 0 0-.232-.095z"/></svg>',
  pinterest:   '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false"><path d="M12 0C5.373 0 0 5.372 0 12c0 5.084 3.163 9.426 7.627 11.174-.105-.949-.2-2.405.042-3.441.218-.937 1.407-5.965 1.407-5.965s-.359-.719-.359-1.782c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738a.36.36 0 0 1 .083.345l-.333 1.36c-.053.22-.174.267-.402.161-1.499-.698-2.436-2.889-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.607 7.464-6.227 7.464-1.216 0-2.359-.632-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0z"/></svg>',
  hacker_news: '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false"><path d="M0 24V0h24v24H0zM6.951 5.896l4.112 7.708v5.064h1.583v-4.972l4.148-7.799h-1.749l-2.457 4.875c-.372.745-.688 1.434-.688 1.434s-.297-.708-.651-1.434L8.831 5.896z"/></svg>',
  email:       '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/></svg>',
  whatsapp:    '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347"/><path d="M12 2C6.477 2 2 6.477 2 12c0 1.89.524 3.66 1.438 5.168L2 22l4.832-1.438A9.953 9.953 0 0 0 12 22c5.523 0 10-4.477 10-10S17.523 2 12 2"/></svg>',
};

export function initSocialSharing( scope ) {
  const roots = ( scope || document ).querySelectorAll(
    '.etp-social-sharing:not([data-etp-ss-ready])'
  );

  roots.forEach( ( root ) => {
    initCopyActions( root );
    initMoreDropdown( root );
    root.dataset.etpSsReady = 'true';
  } );
}

// ── Action: copy to clipboard ────────────────────────────────────────────────

function initCopyActions( container ) {
  container.querySelectorAll( '[data-etp-ss-action="copy"]' ).forEach( ( btn ) => {
    if ( btn.dataset.etpSsCopyBound ) return;
    btn.dataset.etpSsCopyBound = 'true';

    btn.addEventListener( 'click', () => {
      const url = btn.dataset.url || window.location.href;

      if ( navigator.clipboard && navigator.clipboard.writeText ) {
        navigator.clipboard.writeText( url )
          .then( () => showCopiedFeedback( btn ) )
          .catch( () => { legacyCopy( url ); showCopiedFeedback( btn ); } );
      } else {
        legacyCopy( url );
        showCopiedFeedback( btn );
      }
    } );
  } );
}

// ── More dropdown ────────────────────────────────────────────────────────────

function initMoreDropdown( root ) {
  const list = root.querySelector( '.etp-social-sharing__buttons' );
  if ( ! list ) return;

  const moreItem = list.querySelector( '[data-ss-more]' );
  if ( ! moreItem ) return;

  const moreBtn  = moreItem.querySelector( '[data-etp-ss-action="more"]' );
  const dropdown = moreItem.querySelector( '.etp-social-sharing__more-dropdown' );

  function applyVisibility() {
    const max = window.innerWidth <= MOBILE_BREAKPOINT
      ? MAX_VISIBLE.mobile
      : MAX_VISIBLE.default;
    const allItems     = [ ...list.querySelectorAll( '[data-ss-index]' ) ];
    const overflowItems = [];

    allItems.forEach( ( item, i ) => {
      if ( i < max ) {
        item.hidden = false;
      } else {
        item.hidden = true;
        overflowItems.push( item );
      }
    } );

    if ( overflowItems.length > 0 ) {
      moreItem.hidden = false;
      buildDropdown( overflowItems );
    } else {
      moreItem.hidden = true;
      closeDropdown();
    }
  }

  function buildDropdown( overflowItems ) {
    dropdown.innerHTML = '';

    overflowItems.forEach( ( li ) => {
      const service = li.dataset.ssService  || '';
      const label   = li.dataset.ssLabel    || service;
      const href    = li.dataset.ssHref     || '';
      const action  = li.dataset.ssAction   || '';
      const url     = li.dataset.ssUrl      || '';
      const title   = li.dataset.ssTitle    || '';
      const icon    = ICONS[ service ]      || '';

      const menuItem = document.createElement( 'li' );
      menuItem.className = 'etp-social-sharing__more-item';
      menuItem.setAttribute( 'role', 'menuitem' );

      let el;

      if ( href ) {
        el      = document.createElement( 'a' );
        el.href = href;
        el.setAttribute( 'target', '_blank' );
        el.setAttribute( 'rel', 'noopener nofollow' );
      } else {
        el      = document.createElement( 'button' );
        el.type = 'button';
        el.dataset.etpSsAction = action;
        if ( url )   el.dataset.url   = url;
        if ( title ) el.dataset.title = title;
      }

      el.className = 'etp-social-sharing__more-link';
      el.setAttribute( 'aria-label', label );
      el.innerHTML = `${icon}<span>${label}</span>`;

      menuItem.appendChild( el );
      dropdown.appendChild( menuItem );
    } );

    // Bind copy actions on freshly created dropdown elements
    initCopyActions( dropdown );
  }

  function openDropdown() {
    dropdown.hidden = false;
    moreBtn.setAttribute( 'aria-expanded', 'true' );
  }

  function closeDropdown() {
    dropdown.hidden = true;
    moreBtn.setAttribute( 'aria-expanded', 'false' );
  }

  function toggleDropdown() {
    if ( dropdown.hidden ) {
      openDropdown();
    } else {
      closeDropdown();
    }
  }

  // Toggle on More button click
  moreBtn.addEventListener( 'click', ( e ) => {
    e.stopPropagation();
    toggleDropdown();
  } );

  // Close on outside click
  document.addEventListener( 'click', ( e ) => {
    if ( ! dropdown.hidden && ! moreItem.contains( e.target ) ) {
      closeDropdown();
    }
  } );

  // Close on Escape
  document.addEventListener( 'keydown', ( e ) => {
    if ( e.key === 'Escape' && ! dropdown.hidden ) {
      closeDropdown();
      moreBtn.focus();
    }
  } );

  // Initial render
  applyVisibility();

  // Re-apply on viewport resize
  const mq = window.matchMedia( `(max-width: ${MOBILE_BREAKPOINT}px)` );
  mq.addEventListener( 'change', applyVisibility );
}

// ── Helpers ──────────────────────────────────────────────────────────────────

function showCopiedFeedback( btn ) {
  btn.classList.add( 'is-copied' );
  const originalLabel = btn.getAttribute( 'aria-label' );
  btn.setAttribute( 'aria-label', 'Copied!' );

  setTimeout( () => {
    btn.classList.remove( 'is-copied' );
    if ( originalLabel ) {
      btn.setAttribute( 'aria-label', originalLabel );
    }
  }, 2000 );
}

function legacyCopy( text ) {
  const ta = document.createElement( 'textarea' );
  ta.value = text;
  ta.style.position = 'fixed';
  ta.style.opacity  = '0';
  document.body.appendChild( ta );
  ta.focus();
  ta.select();
  try {
    document.execCommand( 'copy' );
  } catch ( e ) {
    // Silent failure — user can copy manually.
  }
  document.body.removeChild( ta );
}
